import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { EyeIcon, EyeOffIcon } from 'lucide-react';
const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const handleSubmit = (e: React.FormEvent) => {
    // e.preventDefault()
    // // In a real app, this would authenticate with a backend
    navigate('/');
  };
  return <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8" data-id="element-84">
      <div className="sm:mx-auto sm:w-full sm:max-w-md" data-id="element-85">
        <h2 className="text-center text-3xl font-extrabold text-gray-900" data-id="element-86">
          LucaGet
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600" data-id="element-87">
          Sign in to your supplier account
        </p>
      </div>
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md" data-id="element-88">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10" data-id="element-89">
          <form className="space-y-6" onSubmit={handleSubmit} data-id="element-90">
            <div data-id="element-91">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700" data-id="element-92">
                Email address
              </label>
              <div className="mt-1" data-id="element-93">
                <input id="email" name="email" type="email" autoComplete="email" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" data-id="element-94" />
              </div>
            </div>
            <div data-id="element-95">
              <label htmlFor="password" className="block text-sm font-medium text-gray-700" data-id="element-96">
                Password
              </label>
              <div className="mt-1 relative" data-id="element-97">
                <input id="password" name="password" type={showPassword ? 'text' : 'password'} autoComplete="current-password" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" data-id="element-98" />
                <button type="button" className="absolute inset-y-0 right-0 pr-3 flex items-center" onClick={() => setShowPassword(!showPassword)} data-id="element-99">
                  {showPassword ? <EyeOffIcon className="h-5 w-5 text-gray-400" data-id="element-100" /> : <EyeIcon className="h-5 w-5 text-gray-400" data-id="element-101" />}
                </button>
              </div>
            </div>
            <div className="flex items-center justify-between" data-id="element-102">
              <div className="flex items-center" data-id="element-103">
                <input id="remember-me" name="remember-me" type="checkbox" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-104" />
                <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-900" data-id="element-105">
                  Remember me
                </label>
              </div>
              <div className="text-sm" data-id="element-106">
                <a href="#" className="font-medium text-blue-600 hover:text-blue-500" data-id="element-107">
                  Forgot your password?
                </a>
              </div>
            </div>
            <div data-id="element-108">
              <button type="submit" className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-109">
                Sign in
              </button>
            </div>
          </form>
          <div className="mt-6" data-id="element-110">
            <div className="relative" data-id="element-111">
              <div className="absolute inset-0 flex items-center" data-id="element-112">
                <div className="w-full border-t border-gray-300" data-id="element-113" />
              </div>
              <div className="relative flex justify-center text-sm" data-id="element-114">
                <span className="px-2 bg-white text-gray-500" data-id="element-115">
                  New to LucaGet?
                </span>
              </div>
            </div>
            <div className="mt-6" data-id="element-116">
              <Link to="/signup" className="w-full flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-117">
                Create an account
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default Login;